import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import Findings from './pages/Findings.vue';

export default [
    {
        path: '/:tenantId/findings',
        name: 'Findings',
        component: Findings,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.Findings, PermissionTypeEnum.FindingManager],
            checkLicence: true,
            title: 'menu.findingsLong',
        },
    },
] as RouteConfig[];
